import { useBucket } from '@mc/experiments-react'
import { CORE_MEMBERSHIP_LANGUAGE_CLEANUP_FLAG_NAME } from '../constants'

export const useLanguageCleanupExperiment = () => {
  const variant = useBucket(CORE_MEMBERSHIP_LANGUAGE_CLEANUP_FLAG_NAME)

  return {
    isVariant: variant?.startsWith('variant'),
  }
}
